import m from "mithril";
import player from "./player";
import tools from "../../tools/tools";
import pf from "../../pf";
import {Icons, ButtonGroup} from "../../plugins/construct-ui/index";

export default () => {
	let loadingContent = true;
	let events = undefined;
	let showvideo = false;
	let loadingvideo = true;
	let title = undefined;
	let description = undefined;

	return {
		oninit: (v) => {
			pf.APIAction("GetData", {
				code: "videos",
				vide: false,
				uid: v.attrs.uid,
			}).then((r) => {
				if (r.success) {
					if (r.description) {
						description = r.description;
						title = r.title;
						loadingContent = false;
						if (!description) showvideo = true;
					} else {
						if (v.attrs.onstop) v.attrs.onstop();
					}
				}
				m.redraw();
			});

			pf.APIAction("GetData", {
				code: "videos",
				video: true,
				uid: v.attrs.uid,
			}).then((r) => {
				if (r.success) {
					// console.log("video done.");
					if (r.data) {
						events = r.data;
						loadingvideo = false;
					} else {
						if (v.attrs.onstop) v.attrs.onstop();
					}
				}
				m.redraw();
			});
		},
		view: (v) => {
			return loadingContent || (!description && loadingvideo)
				? tools.Spinner("Loading")
				: showvideo && !loadingvideo
				? m(player, {
						events,
						new: false,
						onstop: () => {
							if (description) showvideo = false;
							else if (v.attrs.onstop) v.attrs.onstop();
						},
				  })
				: m(".help-article", [
						m(
							".button-section",
							m(ButtonGroup, [
								(loadingvideo || events) &&
									tools.Button(
										"Play Video",
										Icons.PLAY_CIRCLE,
										undefined,
										() => {
											showvideo = true;
										},
										undefined,
										{},
										loadingvideo
									),
								tools.Button("Close", Icons.X_CIRCLE, undefined, () => {
									if (v.attrs.onstop) v.attrs.onstop();
								}),
							])
						),
						m(".title", title),
						m(".description", description),
				  ]);
		},
	};
};
